import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAsterisk: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"asterisk, placeholder"} maskId="square-filled-radius-0-stroke-1-IconAsterisk"><path fillRule="evenodd" clipRule="evenodd" d="M12.5001 2V11.1344L20.411 6.56699L20.911 7.43301L13.0004 12.0002L20.9104 16.567L20.4104 17.433L12.5001 12.866V22H11.5001V12.8664L3.59052 17.433L3.09052 16.567L11.0004 12.0002L3.08984 7.43301L3.58984 6.56699L11.5001 11.134V2H12.5001Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAsterisk;
